import classNames from 'classnames'
import * as React from 'react'
import { LifeInsuranceMedicalExam, LifeInsuranceMedicalExamLabels } from 'ui/multi-product/constants/models'
const FullHeart = require('assets/components/full-heart.svg')
const CrossedOutHeart = require('assets/components/crossed-out-heart.svg')
const QuestionMarkHeart = require('assets/components/question-mark-heart.svg')
const styles = require('./styles')
interface MedicalBadgeProps {
  medicalExam: LifeInsuranceMedicalExam
}
const icon = {
  [LifeInsuranceMedicalExam.ExamRequired]: <FullHeart data-testid="li-full-heart" />,
  [LifeInsuranceMedicalExam.NoExamGuaranteed]: <CrossedOutHeart data-testid="li-crossed-heart" />,
  [LifeInsuranceMedicalExam.NoExamIfQualified]: <QuestionMarkHeart data-testid="li-question-heart" />,
}
export const MedicalBadge: React.FC<MedicalBadgeProps> = (props) => (
  <div className={classNames(styles.badgeWrapper, !props.medicalExam ? styles.invisible : '')}>
    <div className={classNames(styles.badgeItem, 'medical-badge')}>
      {icon[props.medicalExam]}
      <p className={classNames([styles.badgeLabel, 'medical-badge-label'])}>
        {LifeInsuranceMedicalExamLabels[props.medicalExam]}
      </p>
    </div>
  </div>
)
